/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../wire/ApiCaller";
import type {
  CreateSessionRequest,
  CreateSessionResponse,
  GetPresetResponse,
  ListPresetsResponse,
} from "./models";
import {
  createSessionResponseSchema,
  getPresetResponseSchema,
  listPresetsResponseSchema,
} from "./schemas";

export class OnboardingApiClient {
  constructor(private caller: ApiCaller) {}

  async listPresets(timeout?: number): Promise<ListPresetsResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.onboarding.v1.presets.list",
        variables: {},
      },
      "listPresets",
      {},
      { schema: listPresetsResponseSchema, timeout },
    );
  }

  async getPreset(presetId: string, timeout?: number): Promise<GetPresetResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.onboarding.v1.presets.${presetId}.get",
        variables: { presetId: String(presetId) },
      },
      "getPreset",
      {},
      { schema: getPresetResponseSchema, timeout },
    );
  }

  async createSession(
    payload: CreateSessionRequest,
    timeout?: number,
  ): Promise<CreateSessionResponse> {
    return await this.caller.request(
      {
        template: "pip.${companyId}.${userId}.${role}.rpc.onboarding.v1.sessions.create",
        variables: {},
      },
      "createSession",
      payload,
      { schema: createSessionResponseSchema, timeout },
    );
  }
}
